import { isArray, isObject, find, toLower, isEmpty, isString } from 'lodash-es';
import { getAllInfoByISO } from 'iso-country-currency';

const getCountryName = (countryCode) => {
  if (!isEmpty(countryCode)) {
    try {
      return getAllInfoByISO(countryCode).countryName;
    } catch (e) {
      return countryCode;
    }
  }
  return countryCode;
};

const getCurrencyForCountry = (countryCode) => {
  if (!isEmpty(countryCode)) {
    try {
      return getAllInfoByISO(countryCode).currency;
    } catch (e) {
      return null;
    }
  }
  return null;
};

const sanitizeNonProfitAddress = (address, nonProfit) => {
  if (isArray(address)) {
    return sanitizeNonProfitAddress(address[0], nonProfit);
  }
  if (isObject(address)) {
    const addressStr = find(
      address,
      (v, k) =>
        (toLower(k).startsWith('address') ||
          toLower(k).startsWith('line') ||
          toLower(k).startsWith('line1') ||
          toLower(k).startsWith('line2')) &&
        !isEmpty(v),
    );

    return sanitizeNonProfitAddress(addressStr, nonProfit);
  }
  if (isString(address)) {
    try {
      const addressObj = JSON.parse(address);
      return sanitizeNonProfitAddress(addressObj, nonProfit);
    } catch (e) {
      // do nothing. the below code will handle it
    }
  }
  return {
    address: address || '',
    city: nonProfit?.city || nonProfit?.address?.city || '',
    state: nonProfit?.state || nonProfit?.address?.state || '',
    country: getCountryName(
      nonProfit?.country || nonProfit?.address?.country || '',
    ),
    zipcode:
      nonProfit?.zipcode ||
      find(
        nonProfit?.address,
        (val, key) =>
          toLower(key).startsWith('zip') ||
          toLower(key).startsWith('pin') ||
          toLower(key).startsWith('postal'),
      )?.toString() ||
      '',
  };
};

export { getCountryName, getCurrencyForCountry, sanitizeNonProfitAddress };
